module.exports = "https://static-www.niulinkcloud.com/_next/static/media/icon4.f4751c1fc53ef0f572083796389cf9ed.png";